import { API_URL } from 'utils/env/client';

export function isProdEnv() {
  if (!API_URL) return true;

  return API_URL.includes('americandream.com');
}
